import i18n from "@/i18n";
const tableHead = [
    i18n.global.t('page.create-time'),
    i18n.global.t('page.work-order.device-root-sn'),
    i18n.global.t('page.work-order.device-name'),
    i18n.global.t('page.work-order.contact'),
    i18n.global.t('page.user.department'),
    i18n.global.t('page.work-order.contact-phone'),
    i18n.global.t('page.work-order.customer-name'),
    i18n.global.t('also.ExpectedDate'),
    i18n.global.t('page.repair-request.RequestType'),
    i18n.global.t('page.work-order.priority.text'),
    i18n.global.t('page.status'),
    i18n.global.t('page.operation'),
];

const tableBody = [
    {
        id: "t1",
        create_time: '2023-02-01',
        num: 'BS700500115 BS70',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国1',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "low",
        status: "done",
    },
    {
        id: "t2",
        create_time: '2023-02-16',
        num: 'BS700500115 BS71',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国2',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "middle",
        status: "load",
    },
    {
        id: "t3",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS72',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国3',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "high",
        status: "close",
    },
    {
        id: "t4",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS73',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国4',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "low",
        status: "done",
    },
    {
        id: "t5",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS74',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国5',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "middle",
        status: "load",
    },
    {
        id: "t6",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS75',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国6',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "high",
        status: "close",
    },
    {
        id: "t7",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS76',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国7',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "low",
        status: "done",
    },
    {
        id: "t8",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS77',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国8',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "middle",
        status: "load",
    },
    {
        id: "t9",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS78',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国9',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "high",
        status: "close",
    },
    {
        id: "t10",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS79',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国10',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "low",
        status: "done",
    },
    {
        id: "t11",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS80',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国11',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "middle",
        status: "load",
    },
    {
        id: "t12",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS81',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国12',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "high",
        status: "close",
    },
    {
        id: "t13",
        create_time: '2023-02-01 11:25:34',
        num: 'BS700500115 BS82',
        equipment_name: '2BV5-500 2B',
        contacts: '李建国13',
        phone: "18567891234",
        customer_name: "上海重通设备机械有限公司",
        service_time: '2023-02-01',
        priority: "low",
        status: "done",
    },
]

const priorityOptions = [
    { value: '', label: i18n.global.t('page.all') }, //全部
    { value: '1', label: i18n.global.t('page.work-order.priority.not-urgent') },//不紧急
    { value: '2', label: i18n.global.t('page.work-order.priority.urgent') },//紧急
    { value: '3', label: i18n.global.t('page.work-order.priority.very-urgent') },//非常紧急
]

const statusOptions = [
    { value: '1', label: '待处理' },
    { value: '2', label: '已处理' },
    { value: '3', label: '已关闭' },
]

const priorityColor = {
    1: 'bg-success',
    2: 'bg-warning',
    3: 'bg-danger',
}

const statusColor = {
    1: 'badge-soft-warning',
    2: 'badge-soft-info',
    3: 'badge-soft-success',
    4: 'badge-soft-dark',
}

const filterStatus = (type) => {
    let returnData;
    switch (type) {
        case 1:
        case "1":
            returnData = "待处理";
            break;
        case 2:
        case "2":
            returnData = "已处理";
            break;
        case 3:
        case "3":
            returnData = "已关闭";
            break;
    }
    return returnData;
}

const filterPriority = (type) => {
    let returnData;
    switch (type) {
        case 1:
        case "1":
            returnData = i18n.global.t('page.work-order.priority.not-urgent') ;
            break;
        case 2:
        case "2":
            returnData = i18n.global.t('page.work-order.priority.urgent') ;
            break;
        case 3:
        case "3":
            returnData = i18n.global.t('page.work-order.priority.very-urgent') ;
            break;
    }
    return returnData;
}

const detailData = {
    describtion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.',
    tableHead: [
        i18n.global.t('page.device-type') ,
        i18n.global.t('page.device_name') ,
        i18n.global.t('page.pump_head_serial_number') ,
        i18n.global.t('page.unit_serial_number') ,
        i18n.global.t('page.powerOnTime') ,
        i18n.global.t('page.work-order.warranty-status.text') ,
        i18n.global.t('also.EquipmentManager') ,
        i18n.global.t('page.contact_number') ,
    ],
    tableBody: [
    ],
    statusStyle: {
        active: {
            color: 'badge-soft-success',
            text: '在保'
        },
        lazy: {
            color: 'badge-soft-dark',
            text: '脱保'
        }
    }
}

const serviceInfo = [
    {
        label: i18n.global.t('page.status') ,
        value: "",
    },
    {
        label: i18n.global.t('page.repair-request.RequestType') ,
        value: "",
    },
    {
        label: i18n.global.t('page.create-time') ,
        value: "",
    },
    {
        label: i18n.global.t('page.expected-service-time') ,
        value: "",
    },
    {
        label: i18n.global.t('page.work-order.priority.text') ,
        value: "",
    },
]

export {
    tableHead,
    tableBody,
    priorityOptions,
    statusOptions,
    priorityColor,
    statusColor,
    filterStatus,
    filterPriority,
    detailData,
    serviceInfo
};
